import styled from "styled-components";

export const MerchantChartWrapper = styled.div`
  
`;
